import { get } from 'lodash';

import { fetch } from '@utils/utils';

import * as T from '@modules/dictionary/_dictionaryTypes';

const getDictionaryEntity = ({ addError }) => async (
  id: string,
  injectedGetEntityProps?: object
): Promise<T.Dictionary> => {
  try {
    const response: any = await fetch(`/metropolis/api/${get(injectedGetEntityProps, 'url')}/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Dictionary = await response.json();
    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getDictionaryEntity };



// WEBPACK FOOTER //
// ./src/modules/dictionary/_dictionaryActions.ts